import TemplateView from '../../../TemplateView'
import AssignedTeamRow from './AssignedTeamRow'

export default class AssignedTeamList extends TemplateView {
    constructor() {
        super()

        this.state = {
            teamUsers: [],
        }

        this.onStatePropertyChanged('teamUsers', (teamUsers) => {
            this.$teamList.empty()
            for (let user of teamUsers) {
                new AssignedTeamRow({
                    firstName: user.firstName,
                    lastName: user.lastName,
                    middleInitial: user.middleInitial,
                }).init(this.$teamList)
            }
        })
    }

    templateHtml() {
        return '<div class="teamsList"></div>'
    }

    afterRender() {
        this.$teamList = this.getEl()
    }
}



// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/components/AssignedTeamList.js